import { Component } from "react";
import ContactForm from "../ContactMe/ContactForm";
import "./ContactFormSection.css";

class ContactFormSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: props.isMobile,
    };
  }

  render() {
    if (this.state.isMobile()) {
      return (
        <div className="contact-form-section-mobile">
          <div className="contact-form-section-box-mobile">
            <ContactForm />
          </div>
        </div>
      );
    } else {
      return (
        <div className="contact-form-section home-section">
          <div className="contact-form-section-box">
            <ContactForm />
          </div>
        </div>
      );
    }
  }
}

export default ContactFormSection;
